module.exports = __webpack_public_path__ + "static/img/xilanhua.ea3270a7.png";